const initialState = {
	documentId: null,
	isLoading: false
};

export default function UpchunkUploadReducer(state = initialState, action) {
	switch (action.type) {
		case 'MOBILE_UPCHUNK_UPLOAD': {
			return {
				...state,
				document: action.document,
				isLoading: false
			};
		}
		case 'UPCHUNK_DOCUMENT_UPLOAD_PROGRESS': {
			return {
				...state,
				isLoading: true
			};
		}
		case 'UPCHUNK_DOCUMENT_UPLOAD_COMPLETE': {
			return {
				...state,
				isLoading: false
			};
		}
		default:
			return state;
	}
}
